import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator.jsx";
import DatasourceBaseTextFields from "./DatasourceBaseTextFields.jsx";

const DatasourceSyncroMsp = (props) => {

    const Fields = [
        {Identifier:"InstanceDomain", Translation:Translate("Domain"), Hint:"https://<domain>.syncromsp.com", DefaultValue:"https://<domain>.syncromsp.com", Required:true},
        {Identifier:"ApiToken", Translation:Translate("Token"), Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceSyncroMsp.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceSyncroMsp